<div class="no-data-table-text h1">
    No data in table
</div>
<div class="change-filters-text pt-2 body1">
    Try to change the filters
</div>
